import React, { useState } from "react";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import NewOrganization from "./NewOrganization";
import BankInfomatiom from "./BankInfomatiom";
import { FindReview } from "./FindReview";
import { useForm } from "react-hook-form";
import InformationForm from "./InformationForm";
import RightList from "../common/RightList";

const FundPage = () => {
  const [tabs, setTabs] = useState(1);
  const [success, setSuccess] = useState(false);
  const tabslist = [
    {
      id: 1,
      name: "Fund Fundraising",
    },
    {
      id: 2,
      name: "Add New Organization",
    },
    {
      id: 3,
      name: "Banking Information",
    },
    {
      id: 4,
      name: "Final Review",
    },
  ];

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log(data);
    setSuccess(true);
  };

  return (
    <div className="dashboard w-full min-h-screen  flex">
      {/* Sidebar */}
      <Leftsidebar />
      <main className="flex-1 min-w-0 p-4 md:p-6 md:pl-8 ">
        <LeftResponsivesidebar />
        <Headmenu />
        <main className="flex min-w-0">
          <div className="w-[100%] flex min-w-0">
            <div className="w-[100%] min-w-0 lg:w-[70%]">
              <div className="flex flex-col sm:flex-row space-y-5 sm:space-y-0 justify-between sm:items-center py-2">
                <p className="text-xl">Create Fundraising</p>

                <button className="px-8 py-2 border-2 border-[#095228] rounded-[20px]">
                  Save as Draft
                </button>
              </div>
              <div className="flex gap-6 sm:gap-16 mt-5 overflow-x-auto pb-1">
                {tabslist.map((i, id) => (
                  <button
                    key={id}
                    className={`font-[600] shrink-0 whitespace-nowrap ${
                      i.id === tabs ? "text-[#095228]" : "text-gray-500"
                    }`}
                    onClick={() => setTabs(i.id)}
                  >
                    {i.name}
                  </button>
                ))}
              </div>
              <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
                {tabs === 1 ? (
                  <div>
                    <InformationForm
                      register={register}
                      handleSubmit={handleSubmit}
                      errors={errors}
                      watch={watch}
                      onSubmit={onSubmit}
                      setTabs={setTabs}
                    />
                  </div>
                ) : tabs === 2 ? (
                  <div>
                    <NewOrganization
                      register={register}
                      handleSubmit={handleSubmit}
                      errors={errors}
                      watch={watch}
                      onSubmit={onSubmit}
                      setTabs={setTabs}
                    />
                  </div>
                ) : tabs === 3 ? (
                  <div className="">
                    <BankInfomatiom
                      register={register}
                      handleSubmit={handleSubmit}
                      errors={errors}
                      watch={watch}
                      onSubmit={onSubmit}
                      setTabs={setTabs}
                    />
                  </div>
                ) : (
                  tabs === 4 && (
                    <div>
                      <FindReview
                        register={register}
                        handleSubmit={handleSubmit}
                        errors={errors}
                        watch={watch}
                        onSubmit={onSubmit}
                        setTabs={setTabs}
                        setSuccess={setSuccess}
                        success={success}
                      />
                    </div>
                  )
                )}
              </form>
            </div>

            <div className="w-[30%] hidden lg:block">
              <RightList />
            </div>
          </div>
        </main>
      </main>
    </div>
  );
};

export default FundPage;
